import { FC, useEffect, useRef } from 'react';
import theme from 'styles/theme';
import { Box } from '@qga/roo-ui/components';
import { DateRangePicker } from './DateRangePicker';
import { useDateRangePicker } from './lib/useDateRangePicker';
import { DateRange } from './types';
import DateRangeDisplay from './DateRangeDisplay';

interface Props {
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  blockedDates?: Date[];
  isOpen?: boolean;
  onChange: (update: DateRange) => any;
  [key: string]: any;
}

export const DateRangeInput: FC<Props> = ({ startDate, endDate, minDate, maxDate, blockedDates, isOpen, onChange, ...rest }) => {
  const openOnMount = useRef(isOpen || false);

  const dateRangeProps = useDateRangePicker({
    onChange: onChange,
    startDate: startDate,
    endDate: endDate,
    blockedDates: blockedDates,
    minDate: minDate,
    maxDate: maxDate,
  });

  useEffect(() => {
    if (openOnMount.current) {
      dateRangeProps.setIsOpen(true);
      openOnMount.current = false;
    }
  }, [openOnMount, dateRangeProps]);

  return (
    <Box role="group" aria-label="Date range input" {...dateRangeProps.getContainerProps()} zIndex={theme.zIndices.poppers} {...rest}>
      <DateRangeDisplay {...dateRangeProps.getInputProps()} />
      <Box data-testid="date-range-input-popper" role="dialog" aria-label="Date range picker" {...dateRangeProps.getPopperProps()}>
        {dateRangeProps.isOpen && <DateRangePicker {...dateRangeProps} />}
      </Box>
    </Box>
  );
};
